import { render, staticRenderFns } from "./update-vip.vue?vue&type=template&id=53e7ef4c&scoped=true"
import script from "./update-vip.vue?vue&type=script&lang=ts"
export * from "./update-vip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e7ef4c",
  null
  
)

export default component.exports